import { registerRemotes } from '@module-federation/enhanced/runtime';
import { MfeConfig } from '../types/mfe';

export const entryFor = (config: MfeConfig, hostname = window.location.hostname): string =>
  config.urlMapping[hostname] ?? config.urlMapping.localhost;

/** Registers a remote on first use; later calls for the same remote are no-ops. */
export const registerMfeRemote = (config: MfeConfig): void => {
  registerRemotes([{ name: config.remote, entry: entryFor(config) }], { force: false });
};
